const prefix = 'Invariant failed';
function invariant(condition: any, message: string): asserts condition {
  if (condition) {
    return;
  }

  if (process.env.NODE_ENV === 'production') {
    throw new Error(prefix);
  } else {
    throw new Error(`${prefix}: ${message || ''}`);
  }
}

export default invariant;
